export default "__VITE_ASSET__Ca0IPnKD__"